import { NavigationItem } from '.';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import { paths } from '@/constants/paths';

const navigationItems: NavigationItem[] = [
  {
    text: 'dashboard',
    route: paths.teamMember.index,
    icon: <DashboardOutlinedIcon />,
  },
];

export default navigationItems;
